/*************************************************/
/* ANIMATIONS                                    */
/*************************************************/

export function animations() {
    document.addEventListener("DOMContentLoaded", function () {
        function updateWhitespaceHeight() {
            const headlineStickyHeight = document.querySelector(".banner__sticky")?.offsetHeight;
            const whitespaceElement = document.querySelector(".banner-whitespace");
            const whiteStickyElement = document.querySelector(".banner__headline-sticky--white");
            const blackStickyElement = document.querySelector(".banner__headline-sticky--black");
            const whitespaceHeight = headlineStickyHeight + 100;

            if (whitespaceElement) {     
                whitespaceElement.style.height = whitespaceHeight + "px";
                
                whiteStickyElement.style.setProperty("--whitespace-height", whitespaceHeight + "px");
                blackStickyElement.style.setProperty("--whitespace-height", whitespaceHeight + "px");
            }
        }

        updateWhitespaceHeight();

        window.addEventListener("resize", updateWhitespaceHeight);
    });
}
